<div class="canned-service-browse-content">
  <!-- Internal services header -->
  <div class="content-header flex-between-center">
    <p *ngIf="!isPartslookupService" class="mb-0 font-12 font-bold">Canned Service</p>
    <p *ngIf="isPartslookupService" class="mb-0 font-12 font-bold">Magic Services</p>
    <div class="default-cursor flex-start-center" [ngStyle]="{'width': isSubletTrackingEnabled ? '593px' : '530px'}">
      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Labor</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Part</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Tire</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Fee</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1" *ngIf="isSubletTrackingEnabled">
        <span class="font-600">Sublet</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-1">
        <span class="font-600">Other</span>
      </div>

      <div class="flex-start-center font-11 m-width-65 mr-2">
        <span class="font-600">Subtotal</span>
      </div>

      <div class="font-11 pointer font-600 add-est-btn text-center btn-120">Add to {{ orderStatus }}</div>
    </div>
  </div>

  <!-- Internal service list -->
  <div class="canned-service" (scroll)="onScroll($event)" *ngIf="internalServices.length">
    <app-accordian id="canned-service" *ngFor="let service of internalServices; let serviceIndex = index"
      [data]="service" listItemKey="items" listItemLabel="title" listItemIdKey="sitemId" [hasItemCheckbox]="true"
      [iconSize]="10" [fontSize]="12" [index]="serviceIndex" [hasCustomHeader]="true" [hasAccordianSubItem]="true"
      [hasItemSubItem]="true" [hasAccordianSubItemInspection]="!!service?.inspection?.inspectionId"
      [inspectionChecked]="!!selectedServiceInspection[service._id]" [disableInspectionCheckbox]="service?.inspection?.isTireStorageInspection"
      (handleItemSelectChange)="handleSelectChange($event)"
      (handleInspectionItemSelectChange)="handleInspectionSelectChange($event, service)">
      <!-- Service header -->
      <ng-template appTemplate="accordian-header" let-selectAll="selectAll">
        <div class="flex-between-center service-acc-header" (click)="addToEstmate(service, selectAll, $event)">
          <div class="flex-center-center">
            <span class="font-13 font-600 browse-title internal-service-title" [pTooltip]="service?.title">
              {{ currentLang === 'fr' ? ( service?.titleFR || service?.title ) : ( service?.title || service?.titleFR )
              }}
              <span class="pl-2" *ngIf="service.hasPartsLookup">
                <img src="../../../../../../assets/img/lookup.svg" alt="">
              </span>
            </span>
          </div>

          <div class="default-cursor flex-start-center mw-465">
            <!-- Labor -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.labor | currency: usd }}
              </span>
              <span class="flex-center-center">
                <i class="far fa-clock fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.hours || 0 | number: '1.2-2' }}
              </span>
            </div>

            <!-- Part -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.part | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.parts || 0 | number: '1.2-2' }}
              </span>
            </div>

            <!-- Tire -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.tire | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-tire fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.tires || 0 | number: '1.2-2' }}
              </span>
            </div>

            <!-- Fee -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.hazmatFee | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.fees || 0 | number: '1.2-2' }}
              </span>
            </div>

            <!-- Sublet -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1" *ngIf="isSubletTrackingEnabled">
              <span>
                {{ service?.serviceTotal?.sublet | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-store 1 fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.sublet || 0 | number: '1.2-2' }}
              </span>
            </div>

            <!-- Other -->
            <div class="flex-center-end font-12 m-width-65 flex-column mr-1">
              <span>
                {{ service?.serviceTotal?.other | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-stream 1 fa-icon-light-gray pr-2"></i>
                {{ service?.extra?.other || 0 | number: '1.2-2' }}
              </span>
            </div>

            <div class="flex-center-end font-12 m-width-65 flex-column mr-2">
              <span>
                {{ service?.serviceTotal?.total | currency: usd }}
              </span>

              <span class="flex-center-center">
                <i class="far fa-ballot-check fa-icon-light-gray pr-2"></i>
                {{ !!service?.inspection?.inspectionId ? 1 : 0 }}
              </span>
            </div>

            <div *ngIf="selectedInternalServices[service?._id]" id="btn-selected-est{{ serviceIndex }}"
              class="text-center btn-60">
              <div class="font-11 pointer add-est-btn btn-gray">
                Selected
              </div>
            </div>
            <div *ngIf="!selectedInternalServices[service?._id]"
              class="flex-center-start font-12 m-width-65 flex-column mw-107">
              <div id="btn-add-est{{ serviceIndex }}" class="text-center btn-60">
                <div class="font-11 pointer add-est-btn btn-white">
                  Add
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template appTemplate="accordian-sub-item" let-item let-checkboxId="checkboxId">
        <div class="pt-0 ui-g-10">
          <label class="mb-0 pointer width-acc-body" [for]="checkboxId">
            <div class="">
              <div class="ui-g-10 pb-0">
                <div class="font-12">{{ currentLang === 'fr' ? ( item?.titleFR || item?.title ) : ( item?.title ||
                  item?.titleFR ) }}</div>

                <p class="font-11 font-gray-55 service-description text-truncate m-0" [pTooltip]="item?.description"
                  tooltipPosition="top" tooltipStyleClass="list-tooltip">
                  {{ currentLang === 'fr' ? ( item?.descriptionFR || 'No description' ) : ( item?.description ||
                  'No description' )}}
                </p>
              </div>
              <div class="font-12 text-right font-600 font-gray">
                {{ (item?.type == 'bundle' ? item?.flatRate : item.total) | currency: usd }}
              </div>

              <div class="font-9 text-right font-gray">{{ item.quantity }}</div>
            </div>

            <div class="width-px">
              <div class="width-100p mb-0 pb-0 pt-0 pointer ui-g-6"
                *ngFor="let subItem of item.subItems; let i = index">
                <label class="w-100">
                  <div class="custom-checkbox ui-g-1 pb-0 width-3p">
                    <app-checkbox inputId="{{subItem?.itemId}}-{{i}}" label="" [disabled]="!item.isChecked"
                      [isChecked]="subItem.isChecked"
                      (appChange)="handleCheckFlatRateSubItem($event, subItem, item, service)">
                    </app-checkbox>
                  </div>

                  <div class="ui-g-1 pb-0 width-3p pt-2">
                    <i [ngClass]="subItemTypeIcons[subItem?.type]"></i>
                  </div>

                  <div class="ui-g-10 pb-0">
                    <div class="font-12">{{ subItem.title }}</div>

                    <p class="font-11 font-gray-55 service-description text-truncate m-0"
                      [pTooltip]="subItem?.description" tooltipPosition="top" tooltipStyleClass="list-tooltip">
                      {{ subItem?.description || 'No description' }}
                    </p>
                  </div>

                  <div class="mr-2">
                    <div class="font-12 text-right font-600 font-gray">
                      {{ (item?.type == 'bundle' ? subItem?.flatRateAmount : subItem.total) | currency: usd }}
                    </div>

                    <div class="font-9 text-right font-gray">{{ subItem.quantity }}</div>
                  </div>
                </label>
              </div>
            </div>
          </label>
        </div>
      </ng-template>

      <ng-template appTemplate="accordian-sub-item-inspections" let-item let-checkboxId="checkboxId">
        <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
          <div class="font-12">{{ service?.inspection?.title }}</div>

          <div class="flex-column mr-2" [hidden]="service.inspection?.isTireStorageInspection">
            <div class="font-12 text-right font-600 font-gray">
              {{ service?.inspectionCount?.categoryCount }}
              {{ service?.inspectionCount?.categoryCount > 1 ? 'Categories' : 'Category' }}
            </div>

            <div class="font-9 text-right font-gray">
              {{ service?.inspectionCount?.itemCount }}
              {{ service?.inspectionCount?.itemCount > 1 ? 'Items' : 'Item' }}
            </div>
          </div>
        </label>
      </ng-template>
    </app-accordian>

    <p *ngIf="internalServices?.length && isLoading" class="flex-center-center mb-2">
      <span>Loading</span>
      <i class="fal fa-spinner rotate ml-2"></i>
    </p>
  </div>

  <!-- changes made on need on ALP-13204 -->
  <div class="no-data-vector border-0 bg-white" *ngIf="!internalServices.length">
    <img src="../../../../../../assets/img/norecord.png" alt="">
    <p>
      No data available
    </p>
  </div>
  <!-- Canned Service List -->
</div>
